function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useEffect, useState } from 'react';
import { useErrorHandling } from '../hooks/useErrorHandling';
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { buildService } from './service';
import serviceMethods from './service_methods';
const api = buildService('/companies/{id}/subsidiary_companies', {
  only: ['all', 'get']
});
const subsidiaryCompanyService = {
  useFetchAll: _ref => {
    let {
      setLoading,
      companyId,
      fetchImmediately = true
    } = _ref;
    const [subsidiaryCompanies, setSubsidiaryCompanies, fetchSubsidiaryCompanies] = serviceMethods.useFetch({
      callback: useCallback(async () => await api.all(companyId), [companyId]),
      setLoading,
      fetchImmediately
    });
    return [subsidiaryCompanies, setSubsidiaryCompanies, fetchSubsidiaryCompanies];
  },
  useFetchSubsidiaryCompany(companyId, subsidiaryCompanyId, setLoading) {
    const [subsidiaryCompany, setSubsidiaryCompany] = useState(null);
    const fetchSubsidiaryCompany = useErrorHandling(useCallback(async () => {
      setLoading && setLoading(true);
      const company = await subsidiaryCompanyService.get(companyId, subsidiaryCompanyId);
      setSubsidiaryCompany(company);
      setLoading && setLoading(false);
    }, [companyId, subsidiaryCompanyId, setLoading]), useCallback(async () => {
      setLoading && setLoading(false);
    }, [setLoading]));
    useEffect(() => {
      fetchSubsidiaryCompany();
    }, [fetchSubsidiaryCompany]);
    return [subsidiaryCompany, setSubsidiaryCompany];
  },
  useUpdateSubsidiaryCompany(companyId, setSubsidiaryCompany) {
    const updateSubsidiaryCompany = useErrorHandling(useCallback(async subsidiaryCompany => {
      const updatedCompany = await subsidiaryCompanyService.update(companyId, subsidiaryCompany);
      setSubsidiaryCompany && setSubsidiaryCompany(updatedCompany);
      return updatedCompany;
    }, [companyId, setSubsidiaryCompany]));
    return updateSubsidiaryCompany;
  },
  get(companyId, subsidiaryCompanyId) {
    return fetch("/api/companies/".concat(companyId, "/subsidiary_companies/").concat(subsidiaryCompanyId), _objectSpread({}, request.get));
  },
  update(companyId, subsidiaryCompany) {
    return fetch("/api/companies/".concat(companyId, "/subsidiary_companies/").concat(subsidiaryCompany.id), _objectSpread(_objectSpread({}, request.put), {}, {
      body: JSON.stringify({
        subsidiary_company: subsidiaryCompany
      })
    }));
  },
  all(companyId) {
    return fetch("/api/companies/".concat(companyId, "/subsidiary_companies"), _objectSpread({}, request.get));
  },
  destroy(companyId, subsidiaryCompanyId) {
    return fetch("/api/companies/".concat(companyId, "/subsidiary_companies/").concat(subsidiaryCompanyId), _objectSpread({}, request.delete));
  },
  create(companyId, subsidiary_company) {
    return fetch("/api/companies/".concat(companyId, "/subsidiary_companies"), _objectSpread(_objectSpread({}, request.post), {}, {
      body: JSON.stringify({
        subsidiary_company
      })
    }));
  }
};
export default subsidiaryCompanyService;